module.exports = __webpack_public_path__ + "img/9788991095724.cc816360.jpg";